import { motion } from "framer-motion";
import { Clock } from "lucide-react";

export default function Schedule({ content }) {
  const services = content?.services || [];
  return (
    <section id="schedule" data-testid="schedule-section" className="py-24 lg:py-32 bg-[#F3EFEA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-6">
            <div className="text-xs uppercase tracking-[0.2em] text-[#5C6661] mb-4">Gather with us</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#1C201E] leading-tight">
              {content?.heading || "Schedule of Services"}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:text-right">
            <p className="text-[#5C6661] max-w-md lg:ml-auto">
              {content?.subtitle || "Join us for worship, prayer, and the study of God's Word."}
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {services.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`service-card-${i}`}
              className="p-8 bg-[#FAF9F6] border border-[#E5E0D8] rounded-2xl hover:border-[#2C4C3B]/40 transition-colors duration-300"
            >
              <Clock className="w-5 h-5 text-[#D4A373] mb-4" />
              <div className="text-xs uppercase tracking-[0.2em] text-[#5C6661]">{s.day}</div>
              <div className="mt-2 font-serif-display text-3xl text-[#1C201E]">{s.time}</div>
              <div className="mt-3 text-sm text-[#1C201E]/80">{s.name}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
